import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  justify-content: center;
`;

type TabItemPrpos = {
  active?: boolean;
};

export const TabItem = styled.div<TabItemPrpos>`
  border: 1px solid #cbcbcb;
  border-radius: 16px;

  cursor: pointer;
  padding: 3px 10px;
  flex: 1;
  display: flex;
  align-items: center;
  border: 1px solid #cbcbcb;
  -webkit-transition: border 0.3s;
  transition: border 0.3s;
  justify-content: center;
  display: flex;
  align-items: center;

  ${({ active }) =>
    active &&
    css`
      border: 1px solid #0b29fb;
    `}
`;

export const TabText = styled.span<TabItemPrpos>`
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  color: #3d3d3d;
  transition: color 0.3s;

  ${({ active }) =>
    active &&
    css`
      color: #0b29fb;
    `}
`;
